import { useEffect, useRef } from "react";
import { useApp } from "../app-context.tsx";
import { DisplayNameForm } from "./DisplayNameForm.tsx";

/**
 * Asks for the public display name in a modal, the first time someone does
 * something credited to it (a tag). `onDone` runs once the name is saved, so
 * the caller carries on with what was asked; `onCancel` on Escape, the close
 * button or a click outside.
 */
export function DisplayNameDialog({ open, onDone, onCancel }: { open: boolean; onDone: () => void; onCancel: () => void }) {
  const { copy } = useApp();
  const ref = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    const d = ref.current;
    if (!d) return;
    if (open && !d.open) {
      d.showModal();
      // showModal focuses the first control (the ×), where Enter would dismiss: start in the name field.
      d.querySelector<HTMLInputElement>("input")?.focus();
    }
    if (!open && d.open) d.close();
  }, [open]);
  return (
    <dialog
      ref={ref}
      className="cfg-dialog display-name-dialog"
      aria-labelledby="display-name-title"
      onCancel={(e) => {
        e.preventDefault();
        onCancel();
      }}
      onClick={(e) => e.target === ref.current && onCancel()}
    >
      <div className="cfg-dialog-body">
        <div className="cfg-dialog-head">
          <h2 id="display-name-title" className="cfg-dialog-title">
            {copy("profile.dialogTitle")}
          </h2>
          <button type="button" className="cfg-fit-remove cfg-dialog-close" aria-label={copy("common.dismiss")} onClick={onCancel}>
            ×
          </button>
        </div>
        {open && <DisplayNameForm onDone={onDone} autoFocus />}
      </div>
    </dialog>
  );
}
